import { OfferStatus } from '@today/types'
import { Badge } from '@today/ui-primitives'
import type { ReactElement } from 'react'
import type { Translate } from './offer-types'

const STATUS_VARIANT: Record<OfferStatus, 'muted' | 'success' | 'secondary' | 'danger' | 'primary'> = {
	[OfferStatus.DRAFT]: 'muted',
	[OfferStatus.SENDING]: 'secondary',
	[OfferStatus.SEND_FAILED]: 'danger',
	[OfferStatus.SENT]: 'primary',
	[OfferStatus.EXPIRED]: 'secondary',
	[OfferStatus.REVOKED]: 'secondary',
	[OfferStatus.CONVERTED]: 'success',
	[OfferStatus.ERROR]: 'danger',
}

/** The offer status as a badge labelled by `status.<value>`. */
export function OfferStatusBadge({ t, status }: { t: Translate; status: OfferStatus }): ReactElement {
	return <Badge variant={STATUS_VARIANT[status]}>{t(`status.${status}`)}</Badge>
}
